<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-200">
    <div class="w-full max-w-5xl flex flex-col md:flex-row bg-white rounded-2xl overflow-hidden shadow-lg">

      <!-- Left Panel -->
      <div class="w-full md:w-1/2 px-10 py-12">

        <div class="kenscio-logo flex justify-center">
          <img src="@/assets/images/kenscio-logo.png" alt="kenscio-logo" class="w-14 mt-2" />
        </div>
        <h1 class="text-3xl font-bold text-gray-500 mt-6 ml-28">Create Account</h1>

        <el-form ref="form" :model="registerForm" :rules="registerRules" label-position="top" class="max-w-md mt-10">
          <el-form-item label="Name" class="form-label" prop="name">
            <el-input v-model="registerForm.name" type="text" placeholder="Name" class="custom-input" required />
          </el-form-item>
            <el-form-item label="Email Id" class="form-label" prop="username">
              <el-input v-model="registerForm.username" type="email" placeholder="Email" class="custom-input" required />
            </el-form-item>
            <el-form-item label="Password" class="form-label" prop="password">
              <el-input v-model="registerForm.password" type="password" placeholder="Password" class="custom-input" />
            </el-form-item>
            <el-form-item label="Confirm Password" class="form-label" prop="confirmPassword">
              <el-input v-model="registerForm.confirmPassword" type="password" placeholder="Confirm Password" class="custom-input" />
            </el-form-item>
          <div class="flex flex-col md:flex-row justify-center gap-4 mt-20">
            <el-button type="submit" class="resisterBtn w-full md:w-32 " @click.prevent="handleRegister">
              Create Account
            </el-button>
            <el-button class="signIn w-full md:w-32" @click="$router.push({ name: 'login-page' })">
              Sign In
            </el-button>
          </div>
        </el-form>
      </div>

      <!-- Right Panel with Image and Quote -->
      <div class="right-image w-full md:w-1/2 relative">
        <img src="@/assets/images/registerImg.png" class="w-full h-full object-cover" />
        <div class="absolute bottom-6 left-6 bg-white/80 backdrop-blur-md p-6 rounded-lg max-w-sm shadow-lg">
          <p class="text-sm text-gray-700 italic mb-3">
            You can identify trends in email engagement to optimize your sales email subject lines, templates, and follow-up strategies.</p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import registerPage from "./registerPage.js";
export default registerPage;
</script>

<style scoped>
/* Ensure full height */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}



/* Labels */
.form-label {
  font-size: 12px;
  color: #08354b;
}

.resisterBtn {
  background-color: #0c5c6d;
  color: #ffffff;

}

.resisterBtn:hover {
  background-color: #138d9c;
  color: #ffffff;
  transition: background-color 0.3s ease,

}

.signIn{
  color: #302929;
  background-color: #acbdc1;
  margin-left: 0 !important;

}
.signIn:hover{
  background-color: #d5e4e6;
  color: #ffffff;
  transition: background-color 0.3s ease,
}
/* Inputs */
.custom-input {
  border: none;
  border-bottom: 1px solid #0c5c6d;
  background-color: transparent;
  outline: none;
  font-size: 12px;
  padding: 2px 0;
  transition: all 0.3s ease-in-out;
}

.custom-input:focus {
  border-bottom: 2px solid #08354b;
  transform: scale(1.03);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  h2 {
    font-size: 1.8rem;
  }
  .kenscio-logo{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .right-image{
    display: none;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 1.5rem;
  }
  .kenscio-logo{
    margin-top: 10px;
  }
  .right-image{
    display: none;
  }
  
  .resisterBtn,
  .w-full {
    font-size: 0.9rem;
    padding: 10px;
  }
}

</style>